import React, { useLayoutEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { localizeLink } from '../utils'
import { iOS, android, appButtonUrls } from '../device'
import { getSessionItem, setSessionItem } from '../storeManager'
import { FormattedMessage } from 'react-intl'
import { setEntryPoint, trackStartRegistration } from '../analytics'
import { useSelector } from 'react-redux'
import { selectIsAuthenticated } from 'js/store/userSlice'
import { isSSR } from 'js/isSSR'

import CloseIcon from '!!@svgr/webpack!media/close.svg'
import { ga } from 'js/analytics/adapters'
import useLocale from 'js/hooks/useLocale'

type Props = {
  install: boolean
}

const InstallBanner = ({ install = false }: Props) => {
  const { language } = useLocale()
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const [link, setLink] = useState<string | null>(null)
  const [storeText, setStoreText] = useState('')
  const [shouldRender, setShouldRender] = useState(false)

  useLayoutEffect(() => {
    const timeoutId = window.setTimeout(() => {
      // Only show banner once per session
      if (!getSessionItem('bannerShown')) {
        setShouldRender(true)
        setLink(iOS ? appButtonUrls.apple : appButtonUrls.google)
        setStoreText(iOS ? 'App Store' : 'Google Play')
      }

      setSessionItem('bannerShown', true)
    }, 500)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [])

  const close = () => {
    setShouldRender(false)
  }

  const trackClick = () => {
    if (!isAuthenticated) {
      ga.track('Install Banner Click')
    }
  }

  if (isSSR) return null
  if (navigator.userAgent.match('DisableForTesting')) return null
  if (!(iOS || android)) return null

  return (
    <div className="c-install-banner">
      {shouldRender && typeof link === 'string' && (
        <div className="c-install-banner__inner">
          <button onClick={close} className="text-grey-lighter">
            <CloseIcon width="12" height="12"></CloseIcon>
            <span className="sr-only">Close banner</span>
          </button>
          <img
            className="rounded-8"
            src={require('media/app-icon.jpg')}
            alt="Lifesum app icon"
          />
          <div>
            <span className="c-install-banner__heading">Lifesum</span>
            <div className="c-review  c-install-banner__stars">
              <div className="c-review__rating  c-review__rating--4-5" />
            </div>
            <span className="c-install-banner__store">{storeText}</span>
          </div>
          {install && (
            <a
              className="ml-auto text-center text-green font-demibold border-2 border-color-green rounded-4 px-16 py-2"
              href={link}
              onClick={trackClick}
            >
              <FormattedMessage id="install_now" defaultMessage="Install now" />
            </a>
          )}
          {!install && (
            <Link
              to={localizeLink('/signup/', language)}
              className="ml-auto text-center text-green font-demibold border-2 border-color-green rounded-4 px-16 py-2"
              onClick={() => {
                setEntryPoint('InstallBanner')
                trackStartRegistration()
              }}
            >
              <FormattedMessage
                id="Header.menuBar.signUp"
                defaultMessage="Sign up"
              />
            </Link>
          )}
        </div>
      )}
    </div>
  )
}

export default InstallBanner
